import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner, Typography } from "@bookips/sds";
import ExpiredPassCard from "./ExpiredPassCard";
import MyPassCard from "./MyPassCard";
const PassList = (param)=>{
    let { items , variant , isLoading , onOpenInfo  } = param;
    if (isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-[200px] items-center justify-center",
            children: /*#__PURE__*/ _jsx(Spinner, {
                size: "md",
                className: "text-gray-300"
            })
        });
    }
    if (!items || items.length === 0) {
        const emptyMessage = "해당하는 이용권이 없어요.";
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-[200px] items-center justify-center",
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "body1",
                className: "text-secondary",
                children: emptyMessage
            })
        });
    }
    return /*#__PURE__*/ _jsx("ul", {
        className: "flex flex-col",
        children: items.map((pass)=>/*#__PURE__*/ _jsx("li", {
                children: variant === "active" ? /*#__PURE__*/ _jsx(MyPassCard, {
                    pass: pass,
                    onOpenInfo: onOpenInfo
                }) : /*#__PURE__*/ _jsx(ExpiredPassCard, {
                    pass: pass,
                    onOpenInfo: onOpenInfo
                })
            }, pass.membershipId))
    });
};
export default PassList;
